<template>
  <div>
    <h1 class="m-label" style="margin: 0">生徒一覧</h1>
    <div class="m-box__inner2">

      <transition name="loading" mode="out-in">
        <template v-if="family.students">

          <ul class="m-List">
            <li class="m-Item" v-for="(list, index) in mapStudents" :key="index.id">

              <div class="m-Item__block" v-bind:class="{ unknown: list.gender === 0, boy: list.gender === 1, girl: list.gender === 2 }" @click="linkStudent(list)">
                <!-- <div class="m&#45;Item__content" v&#45;bind:class="[{ gray: new Date(Date.parse(list.service_period_end)) < new Date() }, { gray: list.state === 7 }, { gray: list.state === 8 }]"> -->
                <div class="m-Item__content" v-bind:class="{ gray: new Date(Date.parse(list.service_period_end)) < new Date() && list.state !== 1 }">
                  <i class="fa fa-user-circle"></i>
                  <div>
                    状態 :
                    <span v-if="list.state === 0"></span>
                    <span v-if="list.state === 1">指導中</span>
                    <span v-if="list.state === 2">休止</span>
                    <span v-if="list.state === 3">CXL</span>
                    <span v-if="list.state === 4">終了</span>
                  </div>
                  <div>{{list.f_name}} {{list.l_name}} ({{list.f_name_kana}} {{list.l_name_kana}})</div>
                  <div>
                    学年 :
                    <template v-if="list.school_type === 0"></template>
                    <template v-if="list.school_type === 1">公立 </template>
                    <template v-if="list.school_type === 2">国立 </template>
                    <template v-if="list.school_type === 3">私立 </template>
                    <template v-if="list.school_type === 4">その他 </template>
                    {{list.school_name}}
                    {{list.mapGrade}}
                    {{list.age}}歳
                  </div>
                  <div v-for="(list, index) in list.student_tutors" :key="index">
                    <template v-if="list.tutor">
                      先生 : {{list.tutor.f_name}} {{list.tutor.l_name}} {{list.mapGuidance_period_start}}~{{list.mapGuidance_period_start}}
                    </template>
                  </div>
                  <div>役務期間 : {{list.service_period_start}} ~ {{list.service_period_end}}</div>
                  <div>備考 : {{list.note}}</div>
                  <div>契約内容</div>
                  <li v-for="(list, index) in list.agreements" :key="index.id">
                    <div>契約日 : {{list.contract_date}} , 契約種類 : {{list.contract_type}} , 担当AD : {{list.person}}</div>
                    <div>商品名 : {{list.product_name}}</div>
                    <div>入会金 : {{list.admission_fee_check}}</div>
                    <div>保証金 : {{list.deposit_check}}</div>
                  </li>
                </div>
                <div class="m-Item__content2">
                  <btn class="jump" @click.native="linkStudent(list)"><i class="fa fa-address-card"></i></btn>
                  <btn class="delete" @click.native="deleteFamilyStudent(list)"><i class="fa fa-trash"></i></btn>
                </div>
              </div>

            </li>
          </ul>

        </template>
        <template v-else>
          <loading></loading>
        </template>
      </transition>

    </div>
    <family-students-modal :family="family"></family-students-modal>
  </div>
</template>

<script>
let _ = window._
export default {
  props: {
    family: Object
  },
  name: 'FamilyStudentsIndex',
  data () {
    return {

    }
  },
  computed: {
    // order By
    orderedStudents () {
      return _.orderBy(this.family.students, 'service_period_start', 'desc')
    },

    mapStudents () {
      let self = this
      return self.orderedStudents.map(student => {
        student.age = self.calcAge(student.birthday)
        student.mapGrade = self.calcGrade(student.birthday, student.grade_flag)
        student.student_tutors.map(student_tutor => {
          student_tutor.mapGuidance_period_start = self.calcDateTime(student_tutor.guidance_period_start)
          student_tutor.mapGuidance_period_end = self.calcDateTime(student_tutor.guidance_period_end)
        })
        // console.log(student)
        return student
      })
    }
  },
  methods: {
    calcDateTime (val) {
      const datetime = new Date(val)
      const year = datetime.getFullYear()
      let month = datetime.getMonth() + 1
      month = month.toString()
      month = month.padStart(2, '0')
      let date = datetime.getDate()
      date = date.toString()
      date = date.padStart(2, '0')
      // let hours = datetime.getHours()
      // hours = hours.toString()
      // hours = hours.padStart(2, '0')
      // let minutes = datetime.getMinutes()
      // minutes = minutes.toString()
      // minutes = minutes.padStart(2, '0')
      // return year + '/' + month + '/' + date + ' ' + hours + ':' + minutes
      return year + '/' + month + '/' + date
    },

    // age計算
    calcAge (birthday) {
      // console.log(birthday)
      let x = Date.parse(birthday) // 変換(ミリ秒が返される)
      let date = new Date(x) // ミリ秒をnew Dateに渡す
      let ageDifMs = Date.now() - date // 差分(ミリ秒)
      let ageDate = new Date(ageDifMs) // ミリ秒をnew Dateに渡す
      return ageDate.getUTCFullYear() - 1970
    },

    calcGrade (birthday, grade_flag) {
      // console.log(birthday)
      let x = Date.parse(birthday) // 変換(ミリ秒が返される)
      // console.log(x)
      let birthdate = new Date(x) // ミリ秒をnew Dateに渡す
      // console.log(birthdate)

      // ****/01/01-****/04/01の期間中は学年を上げない
      let year = new Date().getFullYear()
      if (new Date() >= new Date(new Date().getFullYear(), 0, 1) && new Date() <= new Date(new Date().getFullYear(), 3, 1, 23, 59)) {
        year = year - 1
      }
      // console.log(year)

      let ageNumber
      for (let i = 0; i < 100; i++) {
        if (birthdate >= new Date(year - i, 3, 2) && birthdate <= new Date(year - (i - 1), 3, 1, 23, 59)) {
          ageNumber = i
        }
      }

      let gradeNumber = ageNumber + Number(grade_flag)
      // console.log(gradeNumber)

      // 月だけ0から始まるので4月は3
      let grade
      // 幼稚園年少 4年前/04/02-3年前/04/01
      if (gradeNumber === 4) {
        grade = '幼稚園年少'

      // 幼稚園年中 5年前/04/02-4年前/04/01
      } else if (gradeNumber === 5) {
        grade = '幼稚園年中'

      // 幼稚園年長 6年前/04/02-5年前/04/01
      } else if (gradeNumber === 6) {
        grade = '幼稚園年長'

      // 小学1年生 7年前/04/02-6年前/04/01
      } else if (gradeNumber === 7) {
        grade = '小学1年生'

      // 小学2年生 2009/04/02-2010/04/01
      } else if (gradeNumber === 8) {
        grade = '小学2年生'

      // 小学3年生 2008/04/02-2009/04/01
      } else if (gradeNumber === 9) {
        grade = '小学3年生'

      // 小学4年生 2007/04/02-2008/04/01
      } else if (gradeNumber === 10) {
        grade = '小学4年生'

      // 小学5年生 2006/04/02-2007/04/01
      } else if (gradeNumber === 11) {
        grade = '小学5年生'

      // 小学6年生 2005/04/02-2006/04/01
      } else if (gradeNumber === 12) {
        grade = '小学6年生'

      // 中学1年生 2004/04/02-2005/04/01
      } else if (gradeNumber === 13) {
        grade = '中学1年生'

      // 中学2年生 2003/04/02-2004/04/01
      } else if (gradeNumber === 14) {
        grade = '中学2年生'

      // 中学3年生 2002/04/02-2003/04/01
      } else if (gradeNumber === 15) {
        grade = '中学3年生'

      // 高校1年生 2001/04/02-2002/04/01
      } else if (gradeNumber === 16) {
        grade = '高校1年生'

      // 高校2年生 2000/04/02-2001/04/01
      } else if (gradeNumber === 17) {
        grade = '高校2年生'

      // 高校3年生 1999/04/02-2000/04/01
      } else if (gradeNumber === 18) {
        grade = '高校3年生'

      // 未該当
      } else {
        grade = ''
      }
      return grade
    },

    linkStudent (list) {
      this.$router.push({ name: 'studentindex', params: { id: list.id } })
    },

    deleteFamilyStudent (list) {
      this.$store.dispatch('deleteFamilyStudent', list)
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang='scss' scoped>
.loading-leave-active {
  transition: opacity 0s;
  opacity: 0;
}
.loading-enter-active /* .fade-leave-active below version 2.1.8 */ {
  transition: opacity .3s;
}

.unknown {
  border-left: solid 3px #000000;
  .m-Item__content {
    .fa-user-circle {
      color: #000000;
    }
  }
}
.boy {
  border-left: solid 3px #3F51B5;
  .m-Item__content {
    .fa-user-circle {
      color: #3F51B5;
    }
  }
}
.girl {
  border-left: solid 3px #E91E63;
  .m-Item__content {
    .fa-user-circle {
      color: #E91E63;
    }
  }
}
.gray {
  background: #dddddd;
}
.m-List {
  list-style-type: none;
  margin:0;
  padding:0;
}
.m-Item {
  border: 1px solid #eee;
  position: relative;
  .fa-user-circle {
    font-size: 50px;
    margin-bottom: 5px;
  }
  &__block {
    word-wrap: break-word;
    display: flex;
    .m-Item__content {
      flex-grow: 1;
      width: 85%;
      padding: 1em;
    }
    .m-Item__content2 {
      flex-grow: 1;
      width: 30px;
      display: flex;
      flex-flow: column nowrap;
      .jump {
        /* background: #37474F; */
        margin: 0;
        flex-grow: 3;
        padding: 0;
      }
      .delete {
        background: #546E7A;
        margin: 0;
        flex-grow: 1;
        padding: 0;
      }
    }
  }
}
.m-box__inner2 {
  height: calc(100vh - 262px);
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// FamilyStudentsIndex.vue?7ea34d56